(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.onScroll = this.onScroll.bind(this);

      this.preventReveal = false;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {
        top: 0,
        bottom: this.header.offsetHeight
      };

      this.currentScrollTop = 0;

      this.setHeaderHeight();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScroll,
        false
      );

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScroll
      );
    }

    setHeaderHeight() {
      if (!this.header) return;

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        if (entries.length) {
          this.headerBounds = entries[0].intersectionRect;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (
        this.predictiveSearch &&
        this.predictiveSearch.isOpen
      ) {
        return;
      }

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add(
          'scrolled-past-header'
        );

        if (!this.headerIsAlwaysSticky) {
          requestAnimationFrame(
            this.hide.bind(this)
          );
        }
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add(
          'scrolled-past-header'
        );

        if (
          !this.preventReveal &&
          !this.headerIsAlwaysSticky
        ) {
          requestAnimationFrame(
            this.reveal.bind(this)
          );
        } else if (this.preventReveal) {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = window.setTimeout(() => {
            this.preventReveal = false;
          }, 66);
        }
      } else if (
        scrollTop <= this.headerBounds.top
      ) {
        this.header.classList.remove(
          'scrolled-past-header'
        );

        if (!this.headerIsAlwaysSticky) {
          requestAnimationFrame(
            this.reset.bind(this)
          );
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeCustomMenu();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );
    }

    reset() {
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeCustomMenu() {
      const detailsItems =
        this.header.querySelectorAll(
          '.mv-menu-details[open]'
        );

      detailsItems.forEach((details) => {
        details.removeAttribute('open');
      });

      document.documentElement.classList.remove(
        'mv-header-menu-open'
      );
    }

    closeSearchModal() {
      const searchModals =
        this.header.querySelectorAll(
          'details-modal'
        );

      searchModals.forEach((modal) => {
        if (
          modal &&
          typeof modal.close === 'function'
        ) {
          modal.close(false);
        }
      });
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define(
      'sticky-header',
      StickyHeader
    );
  }

  function initMonvazaHeaderMenu() {
    const header =
      document.querySelector(
        '.section-header .header'
      );

    if (!header) return;

    if (
      header.dataset.mvMenuReady === 'true'
    ) {
      return;
    }

    header.dataset.mvMenuReady = 'true';

    const detailsItems = Array.from(
      header.querySelectorAll(
        '[data-mv-menu-details]'
      )
    );

    if (!detailsItems.length) return;

    function updateMenuHeight() {
      const wrapper =
        document.querySelector(
          '.section-header .header-wrapper'
        );

      if (!wrapper) return;

      const rect =
        wrapper.getBoundingClientRect();

      const remaining =
        Math.max(
          window.innerHeight - rect.bottom,
          420
        );

      document.documentElement.style.setProperty(
        '--mv-menu-height',
        `${remaining}px`
      );
    }

    function closeAll(except) {
      detailsItems.forEach((details) => {
        if (
          details !== except &&
          details.hasAttribute('open')
        ) {
          details.removeAttribute('open');
        }
      });
    }

    function syncOpenState() {
      const open =
        detailsItems.some((details) =>
          details.hasAttribute('open')
        );

      document.documentElement.classList.toggle(
        'mv-header-menu-open',
        open
      );

      if (open) {
        updateMenuHeight();
      }
    }

    detailsItems.forEach((details) => {
      details.addEventListener(
        'toggle',
        function () {
          if (
            details.hasAttribute('open')
          ) {
            closeAll(details);
          }

          syncOpenState();
        }
      );

      const closeButton =
        details.querySelector(
          '[data-mv-menu-close]'
        );

      if (closeButton) {
        closeButton.addEventListener(
          'click',
          function () {
            details.removeAttribute('open');
            syncOpenState();
          }
        );
      }
    });

    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Escape') return;

        closeAll(null);
        syncOpenState();
      }
    );

    window.addEventListener(
      'resize',
      updateMenuHeight,
      { passive: true }
    );

    updateMenuHeight();
  }

  initMonvazaHeaderMenu();

  document.addEventListener(
    'shopify:section:load',
    initMonvazaHeaderMenu
  );

  } catch(e) { console.error(e); }
})();
})();
